import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { FragmentNames, MyChartViewTeleconsultationRecordAliases } from '../../codegen';
import { ImageAPI, LayoutAPI, LoaderAPI, PanelAPI, PDFViewerAPI, VideoStreamAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { isMobile, resolvePath } from '@philips-internal/oswald-ui-utils';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { ALLOWED_FILE_PREVIEW_EXTENTIONS } from '../../constants/allowed-file-preview-extentions';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import './my-chart-view-teleconsultation-record.css';
import { LayoutAlign } from '@philips-internal/oswald-ui-constants';
import { ReportGenerateResponse } from '../../constants/report-generate-response-interface';
import { MapTelehealthRecordsData } from '../../constants/my-chart-teleconsultation-interface';
import { TeleconsultationRecordsLabels } from '../../constants/my-chart-teleconsultation-types';

@Controller({ fragment: FragmentNames.MY_CHART_VIEW_TELECONSULTATION_RECORD })
export default class MyChartTeleconsultationController extends BaseController {

  @Inject(MyChartViewTeleconsultationRecordAliases.VIDEO_STREAM_CONSULTATION)
    videoStreamAPI!: VideoStreamAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.PANEL_VIDEOSTREAM)
    panelVideoStreamAPI!: PanelAPI

  @Inject(MyChartViewTeleconsultationRecordAliases.IMAGE_CHAT)
    imagemChatAPI!: ImageAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.PDF_VIEWER_CHAT)
    pdfViewerAPI!: PDFViewerAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.PANEL_CHAT)
    panelChatAPI!: PanelAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.PANEL_PDF_VIEWER_CHAT)
    panelPdfViewerChatAPI!: PanelAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.PANEL_VIDEOSTREAM)
    panelVideostreamAPI!: PanelAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.LOADER_CONTENT)
    loaderContentAPI!: LoaderAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.PANEL_LOADER)
    panelLoaderAPI!: PanelAPI;

  @Inject(MyChartViewTeleconsultationRecordAliases.LAYOUT_VIEW_TELEHEALTH_RECORD)
    layoutViewTelehealthAPI!: LayoutAPI;

  @OnMount(MyChartViewTeleconsultationRecordAliases.LAYOUT_VIEW_TELEHEALTH_RECORD)
  handleMountLayoutViewTeleconsultationRecords(): void {
    const telehealthRecordsData = this.context.get('teleconsultationData') as MapTelehealthRecordsData;

    if(telehealthRecordsData.registryType === MessageService.translate(TeleconsultationRecordsLabels.CHAT)) {
      HttpService.get(APPLICATION_ENDPOINTS.GET_MC_TELECONSULTATION_REPORT, { 'roomCode': telehealthRecordsData.roomCode })
        .then(response => {
          const body = response.body as ReportGenerateResponse;
          const srcDocumentPath = resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: body.uri });

          this.setPdfViewerProperties(this.pdfViewerAPI, this.layoutViewTelehealthAPI, srcDocumentPath);

          this.disablePanels([this.panelChatAPI, this.panelVideostreamAPI, this.panelLoaderAPI]);
        });

      return;
    }

    this.openOthersTypesOfTelehealthRecords(telehealthRecordsData);
  }

  private openOthersTypesOfTelehealthRecords(telehealthRecordsData: MapTelehealthRecordsData): void {
    const pathDocumentPath = resolvePath(`${APPLICATION_ENDPOINTS.GET_PREVIEW_DOCUMENT}?uri=:uri`, { uri: telehealthRecordsData.link });

    const pathPointSplit = pathDocumentPath.split('.');
    const pathFileType = pathPointSplit[pathPointSplit.length - 1].toLocaleLowerCase();

    switch(pathFileType){
      case ALLOWED_FILE_PREVIEW_EXTENTIONS.JPEG:
      case ALLOWED_FILE_PREVIEW_EXTENTIONS.JPG:
      case ALLOWED_FILE_PREVIEW_EXTENTIONS.PNG:
        this.disablePanels([this.panelPdfViewerChatAPI, this.panelVideostreamAPI]);

        this.imagemChatAPI.setVisible(true);
        this.imagemChatAPI.setSrc(pathDocumentPath);
        this.imagemChatAPI.persistState();
        break;
      case ALLOWED_FILE_PREVIEW_EXTENTIONS.PDF:
        this.disablePanels([this.panelChatAPI, this.panelVideostreamAPI]);

        this.setPdfViewerProperties(this.pdfViewerAPI, this.layoutViewTelehealthAPI, pathDocumentPath);
        break;
      case ALLOWED_FILE_PREVIEW_EXTENTIONS.MP4:
        this.disablePanels([this.panelChatAPI, this.panelChatAPI]);

        this.videoStreamAPI.setEndpoint(pathDocumentPath);
        break;
    }

    setTimeout(() => { this.disablePanels([this.panelLoaderAPI]); }, 5000);
  }

  private setPdfViewerProperties(pdfViewerAPI: PDFViewerAPI, layoutAPI: LayoutAPI, filePath: string): void {
    pdfViewerAPI.setSrc(filePath);
    pdfViewerAPI.setVisible(true);
    pdfViewerAPI.persistState();

    if(isMobile()){
      layoutAPI.setAlignItems(LayoutAlign.END);
      layoutAPI.setLayoutAlign(LayoutAlign.END);
      layoutAPI.persistState();
    }
  }

  private disablePanels(panelApiList: PanelAPI[]): void {
    panelApiList.forEach(panel => panel.setVisible(false));
  }
}
